import { get } from 'lodash'
import { minAge, phone, required, requiredCheck, requiredPhone } from 'utils/validation'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'

const validate = (values, props = {}) => {

  let errors = {
    password: required(get(values, 'password')),
    passwordVerify: required(get(values, 'passwordVerify'))
  }

  // password
  if (
    get(values, 'password') &&
    get(values, 'passwordVerify') &&
    get(values, 'password') !== get(values, 'passwordVerify')
  ) {
    errors = {
      ...errors,
      passwordVerify: {
        text: "Passwords don't match",
        intlKey: 'errors.passwords_dont_match',
        values: {}
      }
    }
  }

  // personal data
  errors = {
    ...errors,
    firstName: required(get(values, 'firstName')),
    lastName: required(get(values, 'lastName')),
    birthDate: required(get(values, 'birthDate')) ||
      minAge(get(values, 'birthDate'), 18),
    minAgeConfirmation: required(get(values, 'minAgeConfirmation')),
    gender: { value: required(get(values, 'gender.value')) },
    line1: required(get(values, 'line1')),
    zipCode: required(get(values, 'zipCode')),
    city: required(get(values, 'city')),
    stateOrProvinceOrRegion: required(get(values, 'stateOrProvinceOrRegion')),
    addressCountryId: required(get(values, 'addressCountryId'))
  }

  // contact data
  errors = {
    ...errors,
    phoneNumber: requiredPhone(get(values, 'phoneNumber')) ||
      phone(get(values, 'phoneNumber')),
    phoneType: {
      value: required(get(values, 'phoneType.value'))
    }
  }

  // polices
  const hasConductEnabled = get(props, `configuration.values[${CONFIGURATION_KEYS.volunteerCodeOfConduct.id}].booleanValue`, false)
  const conductUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.auCoConductDoc.id}].fileUrl`)

  const isNaoRegRequirementEnabled = get(props, `configuration.values[${CONFIGURATION_KEYS.enableNaoRegRequirements.id}].booleanValue`, false)
  const naoRegRequirementUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.naoRegRequirementsUrl.id}].textValue`)

  const isPrivacyPolicyAgreementEnabled = get(props, `configuration.values[${CONFIGURATION_KEYS.enablePrivacyPolicyAgreement.id}].booleanValue`, false)
  const privacyPolicyUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.privacyPolicyUrl.id}].textValue`)

  errors = {
    ...errors,
    naa: (!get(values, 'isIacRegistration') && isNaoRegRequirementEnabled && naoRegRequirementUrl) && requiredCheck(get(values, 'naa')),
    agreementPrivacyPolicy: (isPrivacyPolicyAgreementEnabled && privacyPolicyUrl) && requiredCheck(get(values, 'agreementPrivacyPolicy')),
    agreementCodeOfConduct: (hasConductEnabled && conductUrl) && requiredCheck(get(values, 'agreementCodeOfConduct')),
    terms: requiredCheck(get(values, 'terms'))
  }

  return errors
}

export default validate
